import React, { useCallback } from "react";
import { Box } from "@mui/material";
import ActionButton from "../../../v2/common/ActionButton";
import CircularProgress from "@mui/material/CircularProgress";
import importedStyles from "../../../v2/views/Proactive/Utilities/templateStyles";
import { pluralize } from "../../../v2/views/ProactiveMetricsDetail/ProactiveMetricsDetailUtil";
import BasicTable from "components/v2/common/BasicTable";
import HighlightCard from "./Utilities/HighlightCard";
import HighlightLoader from "./Utilities/HighlightLoader";
import useGetSearchResult from "./Utilities/hooks/useGetSearchResult";
import useGetSearchSummary from "./Utilities/hooks/useGetSearchSummary";
import TextButton from "../../../v2/common/TextButton";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";

export default function SearchComponent({
  page,
  handlePageChange,
  exporting,
  handleExport,
  handleBackButton,
}) {
  const { rows, columns, totalCount, loading } = useGetSearchResult();
  const { searchSummary, loadingSummary } = useGetSearchSummary();

  const handleTableCellClick = useCallback((params) => {
    if (params) {
      window.location.replace(params);
    }
  }, []);

  return (
    <div>
      {loadingSummary && (
        <Box mt={{ xs: "14px", sm: "20px" }}>
          <HighlightLoader />
        </Box>
      )}

      {!loadingSummary && searchSummary?.data?.response && (
        <Box mt="14px">
          <HighlightCard summary={searchSummary.data.response} />
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "24px 0 14px 0",
          gap: "16px",
        }}
      >
        <Box>
          <TextButton
            label={`${totalCount} ${pluralize("result", totalCount)}`}
            action={handleBackButton}
            sx={styles.backButton}
            rootStyle={styles.backButtonRoot}
            startIcon={<ChevronLeftOutlinedIcon sx={styles.backButtonIcon} />}
          />
        </Box>
        <Box sx={{ width: "max-content" }}>
          <ActionButton
            label={exporting ? "Exporting..." : "Export"}
            action={handleExport}
            disabled={exporting || rows?.length === 0}
            withIcon={false}
          />
        </Box>
      </Box>

      {loading && (
        <Box sx={importedStyles.emptyContainer} mt={{ xs: "14px", sm: "20px" }}>
          <CircularProgress size={25} sx={{ color: "#003300" }} />
        </Box>
      )}

      {!loading && rows.length > 0 && (
        <Box mt="14px">
          <BasicTable
            rows={rows}
            columns={columns}
            totalCount={totalCount}
            isPaginationDisabled={loading}
            page={page}
            handlePageChange={handlePageChange}
            handleTableCellClick={handleTableCellClick}
            tableHeadStyle={styles.ellipsis}
            hideHeader={true}
          />
        </Box>
      )}
    </div>
  );
}

const styles = {
  ellipsis: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    height: "10px",
  },
  backButtonIcon: {
    mr: "-5px",
  },
  backButtonRoot: {
    fontSize: "14px",
    height: "20px",
    color: "#0C2728",
    textAlign: "left",
    fontFamily: "LarsseitMedium",
    ":hover": {
      color: "#081a1a",
      backgroundColor: "unset",
    },
    ":disabled": {
      color: "#8c8f8f",
    },
    ":active": {
      outline: "0",
      color: "#0C2728",
    },
  },
};
